"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
  query getVisualizerImagesService(
    $salesModelId: Int
    $configuratorGuid: String
    $version: String
    $navSelections: [NavSelection]
  ) {
    visualizerImagesV2(
      salesModelId: $salesModelId
      configuratorGuid: $configuratorGuid
      version: $version
      navSelections: $navSelections
    ) {
      name
      url
      hash
    }
  }
`;exports.getVisualizerImages=e;
//# sourceMappingURL=queries.js.map
